"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMediaPredicate = useMediaPredicate;

var _react = require("react");

var _useMedia = require("../dist/useMedia");

function useMediaPredicate(query) {
  var result = (0, _useMedia.useMedia)(query);
  return result && result.matches || false;
}